import { render, staticRenderFns } from "./ShowPattern.vue?vue&type=template&id=f2c7d460"
import script from "./ShowPattern.vue?vue&type=script&lang=js"
export * from "./ShowPattern.vue?vue&type=script&lang=js"
import style0 from "./ShowPattern.vue?vue&type=style&index=0&id=f2c7d460&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports